export default function AidentifiedDataIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.6667 4.16667C16.6667 5.54738 13.6819 6.66667 10 6.66667C6.3181 6.66667 3.33333 5.54738 3.33333 4.16667M16.6667 4.16667C16.6667 2.78595 13.6819 1.66667 10 1.66667C6.3181 1.66667 3.33333 2.78595 3.33333 4.16667M16.6667 4.16667V15.8333C16.6667 17.2167 13.7 18.3333 10 18.3333C6.3 18.3333 3.33333 17.2167 3.33333 15.8333V4.16667M16.6667 10C16.6667 11.3833 13.7 12.5 10 12.5C6.3 12.5 3.33333 11.3833 3.33333 10"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
